<template>
    <div> UNUSED!</div>
<!--    <div class="multi-step-">-->
<!--        <design-2021-apprentice-multistep-form-wizard-form-header-component title="Projectnaam">-->
<!--        </design-2021-apprentice-multistep-form-wizard-form-header-component>-->

<!--        <b-alert class="project-name-error"-->
<!--                 show-->
<!--                 variant="danger"-->
<!--                 v-if="hasError">-->
<!--            Projectnaam mag niet leeg zijn.-->
<!--        </b-alert>-->
<!--        <b-form-group class="portfolio-name-group"-->
<!--                      label="Projectnaam"-->
<!--                      label-for="portfolio-name-input">-->
<!--            <template v-slot:label>-->
<!--                Projectnaam: <span class="required">*</span>-->
<!--            </template>-->
<!--            <b-form-input id="portfolio-name-input"-->
<!--                          v-model="text"-->
<!--                          placeholder="projectnaam"-->
<!--                          @input="handleInput">-->
<!--            </b-form-input>-->
<!--        </b-form-group>-->
<!--    </div>-->
</template>

<script>
export default {
    name: "design-2021-apprentice-portfolio-wizard-first-step-component",
    props: ['value'],
    data() {
        return {
            text: this.value,
            hasError: false,
        }
    },

    methods: {
        handleInput(){
            this.$emit('input', this.text);
        },

        async checkForErrors() {
            this.hasError = false;

            if(this.text === ''){
                this.hasError = true;
                const response = true;
                return await response;
            }
        },
    }
}
</script>

<style scoped lang="scss">
    @media(min-width: map-get($grid-breakpoints, 'md')){
        input {
            max-width: 300px;
        }
    }
</style>
